import { useIntl } from 'react-intl';

import type { Maybe } from '@/lib/types';
import { pdpMessages } from '@/messages/product';

import * as S from '../TechnicalData.styles';

export interface TechnicalDataAttribute {
  name: string;
  value: Maybe<string>;
}

export interface SectionProps {
  attributes: TechnicalDataAttribute[];
  handleModalOpen?: (data: string) => void;
  title: string;
}

export const Section = ({
  attributes,
  handleModalOpen,
  title,
}: SectionProps) => {
  const { formatMessage } = useIntl();
  return (
    <S.Section data-test-id='Section'>
      {/* BEC-24926: a titleless section (the mobile reference row) would
          otherwise render an empty heading worth 32px of padding. */}
      {title && <S.Title data-test-id='SectionTitle'>{title}</S.Title>}
      {attributes.map(({ name, value }, index) =>
        value ? (
          <S.NameValueWrapper
            key={name}
            data-test-id={`NameValueWrapper-${index}`}
          >
            <S.Name data-test-id={`Name-${index}`}>{name}</S.Name>
            <S.ValueBox data-test-id={`ValueBox-${index}`}>
              <S.Value
                dangerouslySetInnerHTML={{ __html: value }}
                data-test-id={`Value-${index}`}
              />
              {name ===
                formatMessage(pdpMessages.keyFeaturesWaterResistance) && (
                <S.IconWrapper data-test-id={`IconWrapper-${index}`}>
                  <S.InfoBadgeIcon
                    data-test-id={`InfoBadgeIcon-${index}`}
                    onClick={() => handleModalOpen?.(value)}
                  />
                </S.IconWrapper>
              )}
            </S.ValueBox>
          </S.NameValueWrapper>
        ) : null,
      )}
    </S.Section>
  );
};
